import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, Formik, Form, useFormikContext } from "formik";
import {
  CONVERT_BOOL,
  REQUIRED,
  SelectionField,
  TextField,
} from "../../Components/constants/field";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Common/Loader";
import * as Yup from "yup";
import {
  findByIdSubSector,
  getAllActiveSectors,
  getSubSectorBySectorID,
  insertSubSector,
  updateSubSector,
} from "../../slices/thunks";

export const CreateSubSector = () => {
  const history = useNavigate();
  const { ID } = useParams();
  const dispatch = useDispatch();
  const {
    subSectorDetail: { form },
  } = useSelector((state) => state.SubSector);

  const { sectors, loading: SectorLoading } = useSelector(
    (state) => state.Sector
  );

  useEffect(() => {
    dispatch(getAllActiveSectors());
  }, []);

  useEffect(() => {
    if (ID) {
      let params = {
        ID: ID,
      };
      dispatch(findByIdSubSector(params));
    }
  }, [ID]);

  const handleSubmit = (values) => {
    let obj = {
      ...values,
    };

    obj.IsActive = CONVERT_BOOL.test(obj?.IsActive);
    obj.SectorID = obj.SectorID ? +obj.SectorID : null;

    if (obj?.ID) {
      dispatch(updateSubSector(obj)).then((res) => {
        if (res.payload && res.payload.Status === 200) {
          history(`/subsector`);
        }
      });
    } else {
      delete obj?.ID;
      dispatch(insertSubSector(obj)).then((res) => {
        if (res.payload && res.payload.Status === 200) {
          history(`/subsector`);
        }
      });
    }
  };
  if (SectorLoading) {
    return <Loader />;
  }

  return (
    <div className="page-content">
      <Container fluid>
        <ToastContainer />
        <BreadCrumb title="Sub Sector" pageTitle="Sub Sector" />
        <Row>
          <Col xl={12}>
            <Card color="dark" outline>
              <CardHeader className="bg-light">
                <Row className="align-items-center">
                  <Col md="11">
                    <h4 className="card-title mb-0">
                      {ID ? "Update Sub Sector" : " Create Sub Sector"}
                    </h4>
                  </Col>
                  <Col md="1">
                    <Link to="/subsector">
                      <Button color="primary" block>
                        Back
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg={12}>
                    <Formik
                      enableReinitialize={true}
                      initialValues={form}
                      validationSchema={Yup.object({
                        SectorID: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable()
                          .required(REQUIRED),
                        SubSectorName: Yup.string()
                          .nullable(true)
                          .required(REQUIRED),
                      })}
                      onSubmit={handleSubmit}
                    >
                      {() => {
                        return (
                          <Form noValidate autoComplete="off">
                            <div>
                              <Row>
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="SectorID"
                                    >
                                      Sector:
                                    </Label>
                                    <Field
                                      name="SectorID"
                                      id="SectorID"
                                      options={
                                        Array.isArray(sectors) &&
                                        sectors.map((sector) => {
                                          return {
                                            value: Number(sector.ID),
                                            label: sector.SectorName,
                                          };
                                        })
                                      }
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="SubSectorName"
                                    >
                                      Sub Sector Name:
                                    </Label>
                                    <Field
                                      name="SubSectorName"
                                      className="form-control"
                                      id="SubSectorName"
                                      placeholder="Enter Sub Sector Name"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="IsActive"
                                    >
                                      Status
                                    </Label>
                                    <Field
                                      name="IsActive"
                                      id="IsActive"
                                      options={[
                                        {
                                          label: "Active",
                                          value: true,
                                        },
                                        {
                                          label: "Inactive",
                                          value: false,
                                        },
                                      ]}
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mt-2">
                                <Col lg={12}>
                                  <hr></hr>
                                </Col>
                                <Col md="12" className="text-end">
                                  <Button type="submit" className="success">
                                    Save
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                            <SectorChangeWatcher />
                          </Form>
                        );
                      }}
                    </Formik>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const SectorChangeWatcher = () => {
  const { values } = useFormikContext();
  const dispatch = useDispatch();

  useEffect(() => {
    if (values.SectorID) {
      dispatch(getSubSectorBySectorID(values.SectorID));
    }
  }, [values.SectorID]);
  return null;
};

export default CreateSubSector;
